<div fxLayout="row">
	<div fxFlex>
		<p *ngIf="isSearchRadiusvalid()" class="primary-text font-size-13 text-center font-weight-bold">
			{{ DEADHEAD_MSG }}
		</p>
		<p
			[ngClass]="{ 'label-disabled': originSliderDisabled, 'primary-text': !originSliderDisabled }"
			class="font-size-13 font-weight-bold"
		>
			Origin Deadhead
		</p>
	</div>

	<div fxFlex>
		<div class="primary-text" fxLayout="row" fxLayoutAlign="center center">
			<mat-icon
				(click)="
					!originSliderDisabled &&
						sliderButtonClicked(CARGOCHIEF_KEYS.ORIGIN_DEADHEAD_SLIDER, 'dho', -SLIDER_STEP_SIZE)
				"
				[ngClass]="{ 'cursor-pointer': !originSliderDisabled }"
				[ngStyle]="{ color: originSliderDisabled ? 'grey' : 'primary' }"
			>
				remove
			</mat-icon>
			<mat-slider
				(change)="sliderChanged(CARGOCHIEF_KEYS.ORIGIN_DEADHEAD_SLIDER, sliderModel.dho)"
				[(ngModel)]="sliderModel.dho"
				[disabled]="originSliderDisabled"
				[max]="SLIDER_RANGE.max"
				[min]="SLIDER_RANGE.min"
				[ngModelOptions]="{ standalone: true }"
				[step]="SLIDER_STEP_SIZE"
				[thumbLabel]="true"
				color="primary"
				fxFlex="100"
			>
			</mat-slider>
			<mat-icon
				(click)="
					!originSliderDisabled &&
						sliderButtonClicked(CARGOCHIEF_KEYS.ORIGIN_DEADHEAD_SLIDER, 'dho', SLIDER_STEP_SIZE)
				"
				[ngClass]="{ 'cursor-pointer': !originSliderDisabled }"
				[ngStyle]="{ color: originSliderDisabled ? 'grey' : 'primary' }"
				class="m-r-0-5"
			>
				add
			</mat-icon>
		</div>
	</div>

	<div fxFlex>
		<p
			[ngClass]="{
				'label-disabled': destinationSliderDisabled,
				'primary-text': !destinationSliderDisabled
			}"
			class="font-size-13 font-weight-bold"
			fxLayoutAlign="center center"
		>
			Destination Deadhead
		</p>
	</div>

	<div fxFlex>
		<div fxLayout="row" fxLayoutAlign="center center">
			<mat-icon
				(click)="
					!destinationSliderDisabled &&
						sliderButtonClicked(
							CARGOCHIEF_KEYS.DESTINATION_DEADHEAD_SLIDER,
							'dhd',
							-SLIDER_STEP_SIZE
						)
				"
				[ngClass]="{ 'cursor-pointer': !destinationSliderDisabled }"
				[ngStyle]="{ color: destinationSliderDisabled ? 'grey' : 'primary' }"
			>
				remove
			</mat-icon>
			<mat-slider
				(change)="sliderChanged(CARGOCHIEF_KEYS.DESTINATION_DEADHEAD_SLIDER, sliderModel.dhd)"
				[(ngModel)]="sliderModel.dhd"
				[disabled]="destinationSliderDisabled"
				[max]="SLIDER_RANGE.max"
				[min]="SLIDER_RANGE.min"
				[ngModelOptions]="{ standalone: true }"
				[step]="SLIDER_STEP_SIZE"
				[thumbLabel]="true"
				color="primary"
				fxFlex="100"
			>
			</mat-slider>
			<mat-icon
				(click)="
					sliderButtonClicked(CARGOCHIEF_KEYS.DESTINATION_DEADHEAD_SLIDER, 'dhd', SLIDER_STEP_SIZE)
				"
				[ngClass]="{ 'cursor-pointer': !destinationSliderDisabled }"
				[ngStyle]="{ color: destinationSliderDisabled ? 'grey' : 'primary' }"
			>
				add
			</mat-icon>
		</div>
	</div>
</div>
